/* Common Dawn landing behaviors */
(function () {
  if (window.__cdInit) return;
  window.__cdInit = true;

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    // nav state
    var nav = document.querySelector('.cd-nav');
    var push = document.querySelector('.nav-push');
    if (nav && push) {
      var sizePush = function () { push.style.display = 'block'; push.style.height = nav.offsetHeight + 'px'; };
      sizePush();
      window.addEventListener('resize', sizePush);
      if ('ResizeObserver' in window) new ResizeObserver(sizePush).observe(nav);
    }
    if (nav && !nav.classList.contains('solid')) {
      var onScroll = function () {
        nav.classList.toggle('scrolled', window.scrollY > 40);
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }

    // reveals
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
        });
      }, { threshold: 0.18 });
      document.querySelectorAll('.reveal, .reveal-stagger').forEach(function (el) { io.observe(el); });
    } else {
      document.querySelectorAll('.reveal, .reveal-stagger').forEach(function (el) { el.classList.add('in'); });
    }

    // sunrise scroll moment
    var sunGroup = document.getElementById('cdSunGroup');
    var stage = document.querySelector('.sunrise-stage');
    if (sunGroup && stage) {
      var sunrise = function () {
        var r = stage.getBoundingClientRect();
        var vh = window.innerHeight;
        var p = (vh - r.top) / (vh * 0.85);
        p = Math.max(0, Math.min(1, p));
        var rise = (1 - p) * 95;
        sunGroup.setAttribute('transform', 'translate(0 ' + rise + ')');
        sunGroup.style.opacity = 0.25 + p * 0.75;
      };
      window.addEventListener('scroll', function () { requestAnimationFrame(sunrise); }, { passive: true });
      window.addEventListener('resize', sunrise);
      sunrise();
    }

    // scroll to success message after Shopify redirects back
    if (/customer_posted=true/.test(window.location.search)) {
      var ok = document.querySelector('.wl-success');
      if (ok) ok.scrollIntoView({ block: 'center', behavior: 'smooth' });
    }
  });
})();
